export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = (timeout) => {
  return new Promise((resolve) => setTimeout(resolve, timeout))
}

export function formatSecondsToString (time) {
  let minutes = Math.floor(time / 60)
  minutes = minutes < 10 ? '0' + minutes : minutes
  let seconds = time % 60
  seconds = seconds < 10 ? '0' + seconds : seconds

  return `${minutes}:${seconds}`
}
